import PropTypes from 'prop-types';

import Tabs from 'modules/common/components/Tabs';
import MemberTransactionsList from 'modules/members/components/MemberTransactionsList';
import { transactionsTabsOptions } from 'constants/members';

import { TransactionsContainer } from './MemberTransactions.style';

const MemberTransactions = ({ queryObject, setQueryObject, handleTabSelect }) => (
  <TransactionsContainer>
    <Tabs
      options={transactionsTabsOptions}
      value={queryObject.transactionType}
      onChange={handleTabSelect}
    />
    <MemberTransactionsList queryObject={queryObject} setQueryObject={setQueryObject} />
  </TransactionsContainer>
);

MemberTransactions.propTypes = {
  queryObject: PropTypes.shape({
    transactionType: PropTypes.oneOfType(PropTypes.number, PropTypes.string),
  }).isRequired,
  setQueryObject: PropTypes.func.isRequired,
  handleTabSelect: PropTypes.func.isRequired,
};

MemberTransactions.defaultProps = {};

export default MemberTransactions;
